import type { FC } from 'react'
import { observer } from 'mobx-react-lite'
import { ContainerHeader, Icon, type IContainerHeaderProps, Typography } from 'shared/ui'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import styles from './styles.module.scss'

export type ICallInsightCardsHeaderProps = {
  backCallback?: () => void
}

export const CallInsightCardsHeader: FC<ICallInsightCardsHeaderProps> = observer(
  ({ backCallback }) => {
    const { callPopUpInsightCardsStore } = useCallPopUpDefaultContext()

    const { contactIntegrationsStore } = callPopUpInsightCardsStore

    const handleBack = () => {
      backCallback?.()
      callPopUpInsightCardsStore.closeView()
    }

    const customTitle = contactIntegrationsStore.customTitleIcon ? (
      <div className={styles.customTitleWrapper}>
        <div className={styles.icon}>
          <Icon icon={contactIntegrationsStore.customTitleIcon} />
        </div>
        <Typography
          variant={'body-rg-medium'}
          color={'var(--content-primary-primary)'}
          tag='div'
          ariaLabel={'CustomTitle'}
        >
          {callPopUpInsightCardsStore.titleHeader}
        </Typography>
      </div>
    ) : null

    const props: IContainerHeaderProps = {
      title: callPopUpInsightCardsStore.titleHeader,
      isBorderBottom: true,
      isAutoHeight: true,
      showCount: true,
      titleCount: contactIntegrationsStore.viewAllCount,
      titleVariant: 'body-rg-medium',
      customTitle: customTitle,
      paddingTop: 16,
      paddingRight: 12,
      paddingBottom: 16,
      paddingLeft: 16,
      titleIconButtonProps: {
        size: 'small',
      },
    }

    if (!callPopUpInsightCardsStore.isViewMain) {
      return (
        <ContainerHeader
          className={styles.header}
          {...props}
          titleIconProps={{
            icon: 'chevronLeft',
            color: 'var(--content-primary-tertiary)',
          }}
          actionIconTooltipProps={{
            label: 'Back',
          }}
          titleIconAction={handleBack}
        />
      )
    }

    return null
  }
)
